import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ITEMS = [
  {
    key: 'api',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M8 9l-4 3 4 3M16 9l4 3-4 3M13 5l-2 14" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    key: 'reseller',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" strokeLinecap="round" />
        <circle cx="9" cy="7" r="3.2" />
        <path d="M23 21v-2a3.5 3.5 0 00-2.5-3.3M16.5 3.7a3.2 3.2 0 010 6.2" strokeLinecap="round" />
      </svg>
    ),
  },
] as const;

export function HomeBuilders() {
  const { t } = useTranslation();

  return (
    <section className="dx-builders" id="builders">
      <div className="dx-section__intro">
        <h2>{t('home.builders.title')}</h2>
        <p className="lead">{t('home.builders.subtitle')}</p>
      </div>
      <div className="dx-builders__grid">
        {ITEMS.map((item) => (
          <div key={item.key} className="dx-builders__card">
            <div className="dx-builders__icon">{item.icon}</div>
            <h3>{t(`home.builders.${item.key}.title`)}</h3>
            <p>{t(`home.builders.${item.key}.description`)}</p>
          </div>
        ))}
      </div>
      <div className="dx-builders__actions">
        <a href="/api-docs.html" className="dx-btn dx-btn--primary" target="_blank" rel="noreferrer">
          {t('home.builders.exploreApi')}
        </a>
        <Link to="/reseller" className="dx-btn dx-btn--ghost">
          {t('home.builders.becomeReseller')}
        </Link>
        <Link to="/rocket-saas" className="dx-btn dx-btn--ghost">
          {t('home.builders.learnRocketSaas')}
        </Link>
      </div>
    </section>
  );
}
